// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(title) {
  return function (leftChildrenOpt) {
    const leftChildren = leftChildrenOpt !== undefined ? Caml_option.valFromOption(leftChildrenOpt) : null;
    return function (openMenu) {
      return function (rightChildrenOpt) {
        const rightChildren = rightChildrenOpt !== undefined ? Caml_option.valFromOption(rightChildrenOpt) : null;
        return function (subheaderOpt) {
          const subheader = subheaderOpt !== undefined ? Caml_option.valFromOption(subheaderOpt) : null;
          return function (showMenuOpt) {
            const showMenu = showMenuOpt !== undefined ? showMenuOpt : true;
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          leftChildren,
                                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                className: "text-white",
                                                children: title
                                              })
                                        ],
                                        className: "flex items-center gap-2"
                                      }),
                                  showMenu ? JsxRuntime.jsxs("div", {
                                          children: [
                                            rightChildren,
                                            JsxRuntime.jsx("div", {
                                                  className: "border-l border-asphalt-dark h-5"
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        className: "w-6 h-6",
                                                        src: StaticAsset.src("/static/icons/menu-white-24.svg")
                                                      }),
                                                  onClick: openMenu
                                                })
                                          ],
                                          className: "flex items-center gap-2"
                                        }) : JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  className: "border-l border-asphalt-dark h-5"
                                                }),
                                            rightChildren
                                          ],
                                          className: "flex items-center gap-6"
                                        })
                                ],
                                className: "h-14 bg-black flex justify-between px-4"
                              }),
                          subheader
                        ],
                        className: "flex flex-col"
                      });
          };
        };
      };
    };
  };
}

function AdminDashboardHeaderMobile(Props) {
  return Curry._4(make(Props.title)(Props.leftChildren), Props.openMenu, Props.rightChildren, Props.subheader, Props.showMenu);
}

const make$1 = AdminDashboardHeaderMobile;

export {
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
